module.exports = __webpack_public_path__ + "static/img/头像.c4e4b749.png";